export const CvModels = [
    {
        'ID': 1,
        'Name': 'TransGPT-Vis',
        'Scenes': [
            {
                'TypeName': '城市交通',
                'Desc': '检测路口的非机动车目标：电动车、自行车、三轮车、人',
                'ID': 100100001,
                'Items': [
                    {
                        'BaseModel': 'GLIP-Tiny',
                        'Embedding': 'glip_tiny_citytrans_person_nonmotor_v0.1.json',
                        'LabelName': [
                            'electric scooter',
                            ' bicycle',
                            ' tricycle',
                            'person'
                        ],
                        'Algorithm': '人非机动车',
                        'Desc': '检测路口的非机动车目标：电动车、自行车、三轮车、人',
                        'ID': 100100001
                    }
                ]
            }
        ]
    },
    {
        'ID': 2,
        'Name': 'TransGPT-Vis-beta',
        'Scenes': [
            {
                'TypeName': '城市安全',
                'Desc': '检测地铁站内是否存在积水、烟火',
                'ID': 200200001,
                'Items': [
                    {
                        'BaseModel': 'GLIP-Tiny-beta',
                        'Embedding': 'glip_tiny_beta_citysafety_fire_smoke_water_v0.1.json',
                        'LabelName': [
                            'water',
                            'fire',
                            'smoke',
                            'subway station'
                        ],
                        'Algorithm': '烟火/积水',
                        'Desc': '检测地铁站内是否存在积水、烟火',
                        'ID': 200200001
                    }
                ]
            },
            {
                'TypeName': '轨道交通',
                'ID': 200300001,
                'Desc': '检测地铁站内是否存在特殊乘客：摔倒乘客、轮椅乘客等',
                'Items': [
                    {
                        'BaseModel': 'GLIP-Tiny-beta',
                        'Embedding': 'glip_tiny_beta_subway_special_passenger_v0.1.json',
                        'LabelName': [
                            'felling down passenger',
                            'standing passenger',
                            'squatting down passenger',
                            'sitting passenger',
                            'bending over passenger',
                            'wheelchair passenger'
                        ],
                        'Algorithm': '特殊乘客',
                        'Desc': '检测地铁站内是否存在特殊乘客：摔倒乘客、轮椅乘客等',
                        'ID': 200300001
                    }
                ]
            },
            {
                'TypeName': '智慧金融',
                'Desc': '检测银行网点的运钞车、非机动车等',
                'ID': 200400001,
                'Items': [
                    {
                        'BaseModel': 'GLIP-Tiny-beta',
                        'Embedding': 'glip_tiny_beta_bank_vehicle_v0.1.json',
                        'LabelName': [
                            'securicar',
                            'electric scooter',
                            'bicycle',
                            'car'
                        ],
                        'Algorithm': '运钞车',
                        'Desc': '检测银行网点的运钞车、非机动车等',
                        'ID': 200400001
                    }
                ]
            }
        ]
    },
    {
        'ID': 3,
        'Name': 'TransGPT-Vis-Pro',
        'Scenes': [
            {
                'TypeName': '智慧园区',
                'Desc': '检测社区的非机动车目标：电动车、自行车、三轮车、人、小汽车',
                'ID': 300500001,
                'Items': [
                    {
                        'BaseModel': 'GLIP-Large',
                        'Embedding': 'glip_large_community_person_nonmotor_car_v0.1.json',
                        'LabelName': [
                            'electric scooter',
                            ' bicycle',
                            ' tricycle',
                            'person',
                            ' car'
                        ],
                        'Algorithm': '人非/机动车',
                        'Desc': '检测社区的非机动车目标：电动车、自行车、三轮车、人、小汽车',
                        'ID': 300500001
                    }
                ]
            }
        ]
    }
];

export const Colors = [
    'red',
    'aqua',
    'green',
    'aquamarine',
    'brown',
    'fuchsia',
    'yellow',
    'blue',
    'chartreuse',
    'pink',
    'chocolate',
    'indigo',
    'salmon'
];
